import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AccessibilityPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Accessibility Statement</h1>
        <div className="prose max-w-none bg-white p-8 rounded-lg shadow-sm">
          <p className="text-lg mb-6">Profind.ca is committed to ensuring digital accessibility for people with disabilities. We continuously improve the user experience for everyone and apply relevant accessibility standards.</p>
          
          <h2>Our Commitment</h2>
          <p>We strive to meet WCAG 2.1 Level AA standards and ensure our platform is accessible to all users, including those using assistive technologies.</p>
          
          <h2>Accessibility Features</h2>
          <ul>
            <li>Keyboard navigation support</li>
            <li>Screen reader compatibility</li>
            <li>Clear and consistent navigation</li>
            <li>Sufficient color contrast</li>
            <li>Resizable text</li>
            <li>Alternative text for images</li>
          </ul>
          
          <h2>Ongoing Efforts</h2>
          <p>We regularly review our platform and make improvements to enhance accessibility. Our development team follows best practices for accessible web design.</p>
          
          <h2>Feedback</h2>
          <p>We welcome feedback on the accessibility of Profind.ca. If you encounter any barriers or have suggestions, please contact us:</p>
          <ul>
            <li>Email: accessibility@profind.ca</li>
          </ul>
          
          <p className="mt-6">We aim to respond to accessibility feedback within 2 business days.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AccessibilityPage;